import type { VisitorStatus } from '@/types/dashboard'

interface LiveIndicatorProps {
  status: VisitorStatus
}

export function LiveIndicator({ status }: LiveIndicatorProps) {
  if (status === 'live') {
    // Green pulsing dot - actively using the page
    return (
      <span className="relative flex h-2.5 w-2.5">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500" />
      </span>
    )
  }

  if (status === 'inactive') {
    // Yellow/amber dot - page open but idle
    return (
      <span className="relative flex h-2.5 w-2.5">
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-yellow-400" />
      </span>
    )
  }

  // Gray dot - offline/left the page
  return (
    <span className="relative flex h-2.5 w-2.5">
      <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-gray-300" />
    </span>
  )
}
